export const PRIVACY_POLICY_PAGE = "privacyPolicy";
export const FAQS_PAGE = "faqs";
export const TERMS_OF_USE_PAGE = "termsOfUsePage";
export const EQUIPMENT_TERMS = "vrmEquipmentPage";
export const ORDER_SUMMARY_PAGE = "orderSummaryPage";
export const FINANCIAL_LINE_ITEMS = "financialLineItem";

export const PAGE_TITLE = {
  [PRIVACY_POLICY_PAGE]: "Privacy Policy",
  [FAQS_PAGE]: "FAQs",
  [TERMS_OF_USE_PAGE]: "Terms of Use",
  [EQUIPMENT_TERMS]: "Equipment Terms & Conditions",
};
